import { Card } from '@cmsgov/ds-medicare-gov'
import { MyLink } from 'components/MyLink'
import { EMSN } from 'models/eMSN'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

export interface EMSNCardProps {
  emsn: EMSN
}

export const EMSNCard: FC<EMSNCardProps> = ({ emsn }) => {
  const { t } = useTranslation('eMSNPage')

  return (
    <Card className='my-u-py--8 my-u-px--16 my-u-my--8'>
      <div className='ds-l-row' tabIndex={-1} id={`emsn-card-${emsn.id}`}>
        <div className='ds-l-col--6 ds-l-sm-col--4'>
          <p className='my-u-m--0'>{t('emsn-results.emsn-date-text')}</p>
          <p className='ds-text-heading--lg my-u-m--0 my-u-pb--2'>{emsn.date}</p>
        </div>
        <div className='ds-l-col--6 ds-l-sm-col--4'>
          <p className='my-u-m--0'>{t('emsn-results.claim-type-text')}</p>
          <p className='ds-text-heading--lg my-u-m--0 my-u-pb--2'>{emsn.claimType}</p>
        </div>
        <div className='ds-l-col--12 ds-l-sm-col--4'>
          <div className='my-u-pt--4 my-u-sm-pt--0 ds-u-display--block ds-u-sm-display--flex ds-u-align-items--center ds-u-justify-content--end' style={{ minHeight: '100%' }}>
            <MyLink
              className='ds-c-button ds-u-display--block ds-u-sm-display--inline'
              href={emsn.pdfUrl}
              aria-label={`${emsn.date} ${emsn.claimType} eMSN - ${t('emsn-results.view-pdf-aria-label')}`}
              download
              siteActivityProps={{
                component: 'eMSN',
                clickData: {
                  linkText: 'View PDF',
                  linkUrl: emsn.pdfUrl
                }
              }}
            >
              {t('emsn-results.view-pdf-text')}
            </MyLink>
          </div>
        </div>
      </div>
    </Card>
  )
}
